import { motion } from "framer-motion";
import { ArrowDownRight } from "lucide-react";
import { scrollToId } from "../../lib/lenis";

export default function FinishIndex({ chapters }) {
  return (
    <section data-testid="finish-index" className="bg-bone py-20 lg:py-28 border-b border-ink/10">
      <div className="max-w-[1600px] mx-auto px-5 sm:px-8 lg:px-12">
        <motion.div
          initial={{ opacity: 0, y: 32 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-60px" }}
          transition={{ duration: 0.8, ease: [0.16, 1, 0.3, 1] }}
          className="flex flex-col lg:flex-row lg:items-end justify-between gap-6 mb-12"
        >
          <div>
            <p className="font-mono text-[10px] sm:text-xs uppercase tracking-[0.35em] text-beiged mb-5">The finish library</p>
            <h2 className="font-serif font-black tracking-tight text-ink leading-[1.05] text-4xl sm:text-5xl">
              Eight finishes. <em className="italic text-beiged">One library.</em>
            </h2>
          </div>
          <p className="max-w-md text-sm leading-relaxed text-muted2 lg:text-right">
            Choose a finish — every chapter holds its photographed shutter designs
            with their full shade palette beneath each piece.
          </p>
        </motion.div>

        <div className="grid grid-cols-2 lg:grid-cols-4 border-t border-l border-ink/15">
          {chapters.map((c, i) => (
            <motion.button
              key={c.id}
              data-testid={`index-tile-${c.id}`}
              onClick={() => scrollToId(c.id)}
              initial={{ opacity: 0, y: 24 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-40px" }}
              transition={{ duration: 0.6, delay: (i % 4) * 0.07, ease: [0.16, 1, 0.3, 1] }}
              className="group relative text-left border-b border-r border-ink/15 p-6 sm:p-8 hover:bg-ink transition-colors duration-500"
            >
              <div className="flex items-start justify-between mb-10 sm:mb-14">
                <span className="font-mono text-[10px] tracking-[0.3em] text-beiged group-hover:text-beige transition-colors">{c.num}</span>
                <ArrowDownRight size={16} strokeWidth={1.5} className="text-ink/40 group-hover:text-bone group-hover:translate-x-1 group-hover:translate-y-1 transition-all duration-500" />
              </div>
              <p className="font-serif font-bold tracking-tight text-xl sm:text-2xl text-ink group-hover:text-bone transition-colors leading-tight">
                {c.title}
              </p>
              <p className="font-mono text-[9px] uppercase tracking-[0.25em] text-muted2 group-hover:text-bone/50 mt-2 transition-colors">
                {c.designs.length
                  ? `${c.designs.length} designs${c.noShades ? "" : ` · ${c.colours.length} ${c.unit ?? "shades"}`}`
                  : "coming soon"}
              </p>
            </motion.button>
          ))}
        </div>
      </div>
    </section>
  );
}
